
import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Building, TrendingUp, HardHat, Briefcase, Key } from 'lucide-react';
import Reveal from '../components/Reveal';
import SEO from '../components/SEO';
import './Services.css';

const Services = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100); // Slight delay to ensure render
    }
  }, [hash]);

  const services = [
    {
      id: 1,
      slug: "real-estate-development",
      title: "Real Estate Development",
      icon: <Building size={48} />,
      description: "We identify, acquire, and develop prime properties into residential and commercial masterpieces. Our projects are known for their modern design, sustainability, and high ROI.",
      features: ["Residential Estates", "Commercial Complexes", "Land Acquisition", "Urban Planning"]
    },
    {
      id: 2,
      slug: "property-management",
      title: "Property Management",
      icon: <Key size={48} />,
      description: "Comprehensive management solutions for property owners. We handle maintenance, tenant relations, and financial reporting to ensure your assets perform optimally.",
      features: ["Tenant Management", "Maintenance & Repairs", "Rent Collection", "Legal Compliance"]
    },
    {
      id: 3,
      slug: "building-construction",
      title: "Building & Construction",
      icon: <HardHat size={48} />,
      description: "Delivering high-quality construction projects on time and within budget. Our team of engineers and architects ensures structural integrity and aesthetic excellence.",
      features: ["General Contracting", "Civil Engineering", "project Management", "Renovations"]
    },
    {
      id: 4,
      slug: "investment-services",
      title: "Investment Services",
      icon: <TrendingUp size={48} />,
      description: "Strategic investment advice and opportunities. We help clients grow their wealth through secure and high-yield real estate and business investments.",
      features: ["Portfolio Management", "Market Analysis", "Risk Assessment", "Financial Planning"]
    },

    {
      id: 6,
      slug: "general-contracts",
      title: "General Contracts",
      icon: <Briefcase size={48} />,
      description: "Reliable execution of general supply and service contracts for government and private sector clients.",
      features: ["Procurement", "Supply Services", "Consultancy", "Government Contracts"]
    }
  ];

  return (
    <div className="services-page">
      <SEO 
        title="Our Services | Sotak Investment & Property" 
        description="Comprehensive services including Real Estate Development, Property Management, Construction, and General Contracts."
      />
      <section className="page-header services-header">
        <div className="container">
          <Reveal>
            <h1>Our Services</h1>
            <p>Comprehensive solutions tailored to your needs.</p>
          </Reveal>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="services-list">
            {services.map((service, index) => (
              <Reveal key={service.id} delay={index * 100} className="service-reveal-wrapper">
                <div id={service.slug} className="service-detail-card">
                  <div className="service-icon-wrapper">
                    {service.icon}
                  </div>
                  <div className="service-content">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <ul className="service-features">
                      {service.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      
      <section className="section cta-section text-center">
        <div className="container">
           <Reveal>
             <h2>Need a Custom Solution?</h2>
             <p>Contact our team to discuss your specific requirements.</p>
             <Link to="/contact#contact-form" className="btn btn-secondary">Get a Quote</Link>
           </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Services;
